
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/-/ryco-tv",
      function () {
        return require("private-next-pages/-/ryco-tv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/-/ryco-tv"])
      });
    }
  